import type { AuthUser } from "../context/AuthContext";

export type ProtectedRouteRole = AuthUser["role"];

export type ProtectedRouteGuardInput = {
  isLoading: boolean;
  user: AuthUser | null;
  requiredRole: ProtectedRouteRole;
};

export type ProtectedRouteGuardDecision =
  | { action: "loading" }
  | { action: "allow" }
  | { action: "redirect"; to: string; state?: { from: string } };

export function evaluateProtectedRouteGuard(
  input: ProtectedRouteGuardInput,
  fromPath: string,
): ProtectedRouteGuardDecision {
  if (input.isLoading) {
    return { action: "loading" };
  }

  if (!input.user) {
    return {
      action: "redirect",
      to: "/log-in",
      state: { from: fromPath },
    };
  }

  if (input.user.role !== input.requiredRole) {
    return { action: "redirect", to: "/" };
  }

  return { action: "allow" };
}
